import { MagpieConnection } from 'magpie-lib/connection';
import { tourTopic } from './tour.topic';
import { tourMessages } from './tour.messages';
export const startTour = (tour, onSuccess) => {
  const message = tourMessages.startTour.create(tour);
  MagpieConnection.get().useTopic(tourTopic).publish(message, {
    onReply: reply => {
      if (reply.payload.status === 'success') {
        onSuccess();
      }
    }
  });
};